module.exports = __webpack_public_path__ + "img/next-btn.73b22e4c.svg";